import API_HOST from '../constant/URL'

class ApiService {
    fetchBrand = (lang, kind) => {
        return fetch(`${API_HOST}/vlrg?kind_id=${encodeURIComponent(kind)}` + this.langCode(lang))
            .then( response => response.json() )
            .catch(err => this.handleError('Unable to retrieve list of brands', err))
    }

    fetchModel = (lang, kind, model) => { 
        return fetch(`${API_HOST}/vlrg?kind_id=${encodeURIComponent(kind)}&brand=${encodeURIComponent(model)}` + this.langCode(lang))
            .then(response => response.json())
            .catch(err => this.handleError('Unable to retrieve list of models for brand', err) )
    }

    fetchYear = (lang, model_id,variant_id) =>{
        return fetch(`${API_HOST}/vlrg?model_id=${encodeURIComponent(model_id)}&variant_id=${encodeURIComponent(variant_id)}` + this.langCode(lang))
            .then(response => response.json())
            .catch(err => this.handleError('Unable to retrieve years for model', err) )
    }

    fetchType = (lang, model_id,variant_id, year) =>{
        return fetch(`${API_HOST}/vlrg?model_id=${encodeURIComponent(model_id)}&variant_id=${encodeURIComponent(variant_id)}&year=${encodeURIComponent(year)}` + this.langCode(lang))
            .then(response => response.json())
            .catch(err => this.handleError('Unable to retrieve type list', err) )
    }
   
    fetchBulb = (lang, carID) =>{
        return fetch(`${API_HOST}/uses_and_positions?car_id=${encodeURIComponent(carID)}` + this.langCode(lang))
            .then(response => response.json())
            .catch(err => this.handleError('Unable to retrieve bulb uses and positions', err) )
    }

    fetchTehnology = (lang, carID,selectedBulb) =>{
        return fetch(`${API_HOST}/technologies?car_id=${encodeURIComponent(carID)}&use_id=${encodeURIComponent(selectedBulb)}` + this.langCode(lang))
            .then(response => response.json())
            .catch(err => this.handleError('Unable to retrieve technology', err))
    }

    fetchPillar = (lang, carID,selectedBulb,tehnology) =>{
        return fetch(`${API_HOST}/linecards_and_zmps?car_id=${encodeURIComponent(carID)}&use_id=${encodeURIComponent(selectedBulb)}&technology=${encodeURIComponent(tehnology)}` + this.langCode(lang))
            .then(response => response.json())
            .catch(err => this.handleError('Unable to retrieve pillars', err))
    }

    fetchDescription = (lang, zmp)=>{
        return fetch(`${API_HOST}/product_info?zmp_id=${encodeURIComponent(zmp)}` + this.langCode(lang))
            .then(response => response.json())
            .catch(err => this.handleError('Unable to retrieve description of the product', err) )
    }

    fetchbyPartNumber = (lang, partNumber, kind)=>{
        return fetch(`${API_HOST}/bulb_by_partnumber?kind_id=${encodeURIComponent(kind)}&part_id=${encodeURIComponent(partNumber.toUpperCase())}` + this.langCode(lang))
            .then(response => response.json())
            .catch(err => this.handleError('Unable to retrieve part number', err) )
    }

    fetchbyKba = (kba,kind) =>{
        return fetch(`${API_HOST}/kba_search?kind_id=${encodeURIComponent(kind)}&kba_id=${encodeURIComponent(kba)}` )
            .then(response => response.json())
            .catch(err => this.handleError('Unable to retrieve kbs', err) )
    }

    langCode = (lang) => {
        if (!lang) {
            return '';
        }
        return "&lang_code=" + lang
    }

    handleError = (message, err) => {
        console.error('Unable to retrieve kbs', err)
    }

}

export const apiService = new ApiService();